export const sanitizeActivityTypesParam = (
  activityTypes: string | string[]
) => {
  if (activityTypes === 'all') {
    // server wants nothing set for all activity/sport types, MRE does this when passed undefined
    return undefined;
  }

  if (Array.isArray(activityTypes)) {
    // e.g. "Run,TrailRun,Walk,Hike" (All Foot Sports)
    return activityTypes.join(',');
  }

  return activityTypes;
};
